// Libs
import React, { useState } from 'react';
import { Box, Collapse, Typography } from '@mui/material';

// Components
import Feather from '../../Feather';

// Hooks
import useUser from '../../../hooks/useUser';

import { useStyles } from './FAQCollapsibleCardStyles';

const FAQCollapsibleCard = (props) => {
  const { item } = props;
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ isKiteUser });
  const [cardOpen, setCardOpen] = useState(false);
  return (
    <Box
      data-testid="faq-card"
      display={'flex'}
      flexDirection={'column'}
      className={classes.card}>
      <Box display={'flex'} className={classes.header}>
        <Box flexGrow={1}>
          <Typography variant={isKiteUser ? 'textSmBold' : 'textMdSemibold'}>
            {item.question}
          </Typography>
        </Box>
        <Box height={'24px'}>
          <Feather
            data-testid="collapse-button"
            type={cardOpen ? 'containedRoundedMinus' : 'containedRoundedPlus'}
            onClick={() => setCardOpen(!cardOpen)}></Feather>
        </Box>
      </Box>{' '}
      <Collapse in={cardOpen}>
        <Box borderTop="1px solid #E6E6E6">
          <p>{item.answer}</p>
        </Box>
      </Collapse>
    </Box>
  );
};

export default FAQCollapsibleCard;
